import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Wind: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m309.08 151.04h-64.08v-30h64.08c11.54 0 20.92-9.51 20.92-21.2s-9.38-21.2-20.92-21.2c-6.1 0-11.88 2.69-15.86 7.38l-22.86-19.43c9.69-11.41 23.81-17.95 38.72-17.95 28.08 0 50.92 22.97 50.92 51.2s-22.84 51.2-50.92 51.2z' />
    <path d='m180 151.04h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m219.08 282.49c-14.91 0-29.03-6.54-38.72-17.95l22.86-19.43c3.98 4.69 9.77 7.38 15.86 7.38 11.54 0 20.92-9.51 20.92-21.2s-9.38-21.2-20.92-21.2h-64.08v-30h64.08c28.08 0 50.92 22.97 50.92 51.2s-22.84 51.2-50.92 51.2z' />
    <path d='m90 180.09h90s0 30 0 30h-60c-16.57 0-30-13.43-30-30z' />
    <path d='m414.92 335.09c-26.19 0-47.5-21.31-47.5-47.5s21.31-47.5 47.5-47.5 47.5 21.31 47.5 47.5-21.31 47.5-47.5 47.5zm0-65c-9.65 0-17.5 7.85-17.5 17.5s7.85 17.5 17.5 17.5 17.5-7.85 17.5-17.5-7.85-17.5-17.5-17.5z' />
    <path d='m519.59 93-87.17 182.09-25-15 72.2-152.86c7.11-14.97 25-21.34 39.97-14.23z' />
    <path d='m585.37 452.07-152.95-131.77 21.02-20.21 128.65 109.67c12.59 10.77 14.06 29.71 3.28 42.3z' />
    <path d='m187.42 321.27 197.68-40.99 3.21 28.98-165.35 35.18c-16.21 3.42-32.12-6.96-35.54-23.17z' />
    <path d='m457.42 690.09h-90v-330h30v300h30v-270h30z' />
  </IconBase>
));

Wind.displayName = 'Wind';

export default Wind;
